import axios from 'axios'

export const getMaterialIssues = (params) => {
  return axios.get('/finance/materialIssues', { params })
}

export const getMaterialIssue = (id) => {
  return axios.get(`/finance/materialIssues/${id}`)
}

export const getMaterialIssueLog = ({ id, params } = {}) => {
  return axios.get(`/finance/materialIssues/${id}/logs`, { params })
}

/**
 * Draf baris pengeluaran gabungan dari beberapa permintaan barang: qty yang
 * dikembalikan sudah berupa SISA (qty diminta - qty sudah dikeluarkan).
 * `requestIds` dipisah koma, maksimal 100 id.
 */
export const getMergedMaterialIssueItems = (requestIds) => {
  return axios.get('/finance/materialIssues/merged', { params: { requestIds: requestIds.join() } })
}

export const addMaterialIssue = (data) => {
  return axios.post('/finance/materialIssues', data)
}

export const voidMaterialIssue = (id) => {
  return axios.post(`/finance/materialIssues/${id}/void`)
}

// Alur approval — konvensi rute sama dgn invoice & penyesuaian stok
export const approveMaterialIssue = ({ id }) => {
  return axios.post(`/finance/materialIssues/${id}/approve`)
}

export const rejectMaterialIssue = ({ id, body }) => {
  return axios.post(`/finance/materialIssues/${id}/reject`, body)
}

export const revertApprovalMaterialIssue = ({ id }) => {
  return axios.post(`/finance/materialIssues/${id}/revert`)
}

export const deleteOnAddMaterialIssueAttachment = (url) => {
  return axios.delete('/finance/materialIssues/attachments', { data: { url } })
}
